import AIP_DJAPI,{AIP_DJAPI_URLS} from '../../../api/aipDjapi'

export function getMakeList(){
  let url = `${AIP_DJAPI_URLS.MAKE_LIST}`
  return AIP_DJAPI(
    url,
    {
      method: "GET",
      headers:{
        Accept: 'application/json',
      }
    }
  )
}

export function getModelList(make){
  let url = `${AIP_DJAPI_URLS.MODEL_LIST}${make}/`
  return AIP_DJAPI(
    url,
    {
      method: "GET",
      headers:{
        Accept: 'application/json',
      }
    }
  )
}

export function sendVehicleInquiry(vin,inquiry,token){
  let url = `${AIP_DJAPI_URLS.VEHICLE_INQUIRY}${vin}/`
  if(token){
    url = `${url}?token=${token}`
  }
  return AIP_DJAPI(
    url,
    {
      method: "POST",
      headers:{
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: inquiry
    }
  )
}

export default {
  getMakeList,
  getModelList,
  sendVehicleInquiry,
}
